<template>
	<div class="card mb-4" style="width:100%">
		<div class="card-header">
			
			<div v-if="!['billing', 'payment', 'oderItem', 'billingServiceType', 'notalert'].includes(instanceClassAttr.instanceClass)" style="float:right">
				<b-button id="add" variant="primary" class="btn btn-primary btn-sm" type="button" @click="showModal(NaN, 'new')" v-if="instanceClassAttr.actCol.actAdd">
					<fa icon="plus-circle" width="2em"/>
					{{ $t('default.button.add', { obj: `${ $t(instanceClassAttr.instanceClass + '.label') }`}) }}
				</b-button>
			</div>
			<div class="d-flex justify-content">
				<b-button id="print" variant="primary"
					class="btn btn-info btn-sm" type="button" @click="produce()">
					<fa icon="print"/>
						&nbsp;
						{{this.$t('dataTable.print')}}
				</b-button>
				<modal-pdf-viewer 
					ref="componentModalPdf" 
					:pdfSrc="pdfSrc"
					:pdfName="pdfName"
				/>

				<!-- CSV DOWN -->
				<download-csv style="margin-left:1%"
					id="down"
					type="button"
					class="btn btn-primary btn-sm"
					:data="items"
					:name="instanceClassAttr.instanceClass+'.csv'">
					<fa icon="upload"/>&nbsp;
					{{this.$t('dataTable.download')}}
				</download-csv>
			</div>
		</div>

		<div class="card-body">
			<div class="overflow-auto">
				<div class="form-row" style="margin: 0 -5px">
					<div class="col-md-4">
						<!-- <label>{{ $t('vtabTrans.filter')}}</label> -->
						<b-form-input v-model="filter" :placeholder="$t('vtabTrans.filterPlaceholder')" />
					</div>
					<div class="col-md-6"></div>
					<div class="col-md-2">
						<!-- <label>{{ $t('vtabTrans.page')}}</label> -->
						<b-form-select class="numPerPage" size="sm" v-model="perPage" :options="pageOptions" @change="onChangePerPage">
						</b-form-select>
					</div>
				</div>
			</div>
			<div class="mt-2">
				<b-table
					ref="myTable"
					id="my-table"
					responsive="sm" 
					striped bordered small hover

					:fields="fields" 
					:items="items"
					:current-page="currentPage"
					:label-sort-asc="sortBy"
				>
					<!-- :per-page="perPage" 
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					sticky-header="true" -->

					<!-- FORMAT NUMBER -->
					<template #cell(stock)="props">
						{{$store.getters.formatNumber(props.item.stock)}}
					</template>
					<template #cell(quantity)="props">
						{{$store.getters.formatNumber(props.item.quantity)}}
					</template>

					<!-- FORMAT Double -->
					<template #cell(cost)="props">
						{{$store.getters.formatAmount(props.item.cost)}}
					</template>

					<!-- FORMAT DATE -->
					<template #cell(dateCreated)="props">
						{{$moment(props.item.dateCreated).format($store.getters.formatDate)}}
					</template>
					<template #cell(lastUpdated)="props">
						{{$moment(props.item.lastUpdated).format($store.getters.formatDate)}}
					</template>


					<!-- <template #cell(attrTrans)="props">
						{{props.item[attrTrans]}}
						<b-button ref="trad-row" @click="showModal(props.item.id, 'trans')"
							class="btn btn-datatable btn-icon btn-info mr-2" id="trad-row" v-if="instanceClassAttr.actCol.actGet">
							<fa icon="language"/>
						</b-button>
					</template> -->
					
					<template #cell(actions)="props" v-if="instanceClassAttr.actCol.actDisplay">
						<b-button ref="show-row" @click="showModal(props.item.id, 'show')"
							class="btn btn-datatable btn-icon btn-info mr-2" id="show-row" v-if="instanceClassAttr.actCol.actGet">
							<fa icon="info-circle"/>
						</b-button>
						<b-button ref="edit-row" @click="showModal(props.item.id, 'edit')"
							class="btn btn-datatable btn-icon btn-success mr-2" id="edit-row" v-if="instanceClassAttr.actCol.actEdit">
							<fa icon="edit"/>
							<!-- :title="$t('default.button.update')" -->
						</b-button>
						<b-button v-if="instanceClassAttr.instanceClass === 'repgismodel'" 
							@click="getJrxml(props.item.id, props.item.name)"
							class="btn btn-datatable btn-icon btn-info mr-2">
							<fa icon="print"/>
							<!-- :title="$t('default.button.load')" -->
						</b-button>
						
						<b-button v-if="instanceClassAttr.instanceClass === 'user'" @click="showModal(props.item.id, 'editPwd')"
							class="btn btn-datatable btn-icon btn-dark mr-2">
							<fa icon="user-secret"/>
						</b-button>

						<b-button ref="del-order-row" 
							@click="showModal(props.item.id, 'delete')" class="btn btn-datatable btn-icon btn-danger mr-2" id="del-row" v-if="instanceClassAttr.actCol.actDel">
							<fa icon="trash"/>
							<!-- :title="$t('default.button.delete')" -->
						</b-button>

					</template>
				</b-table>

			</div>
			<div class="mt-3">
				<!-- align="fill/center"  align="center"-->
				<b-pagination @page-click="onPageClick"
					:total-rows="totalRows"
					v-model="currentPage"
					:per-page="perPage"
					style="max-width:50%"
					class="my-0"
					aria-controls="my-table"
					size="sm"
					>
				</b-pagination> 
				<div class="description found" align="right" style="margin-top: -2%">
					{{totalRowsText}}
				</div>
			</div>
		</div>
		<!-- Modal Component -->
		<modal-component ref="componentModal" 
			:instanceClass="instanceClassAttr.instanceClass"
			:modalType="this.selectedModalType"
			:itemId="this.selectedItemId"
			:attrTrans="attrTrans"
			@refreshDataTable="refreshDataTable"
		/>
	</div>

</template>
<script>
	import Modal from '@/components/templates/Modals/Modal.vue'
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue'
	// import PDFViewer from '@/components/templates/PDFViewer.vue';

	export default {
		name: 'datatable-type',
		components: {
			'modal-component': Modal,
			'modal-pdf-viewer': ModalPdfViewer
		},
		props: {
			instanceClassAttr: {
				type: Object,
				required: true
			}
		},
		data () {
			return {
				filter:'',
				totalRows: 0,
				perPage: 10,
				currentPage: 1,
				sortBy: "unitName",
				sortDesc: true,
				/* Number.MAX_SAFE_INTEGER = 9007199254740991 */
				pageOptions: [5, 10, 20, 50, {
					value: Number.MAX_SAFE_INTEGER,
					text: "show all"
				}],
				fields: [],
				items: [],			
				
				selectedItemId: NaN,
				selectedModalType: 'new',

				//no use
				attrsRepList:[],
				attrsRepLibList:[],
				attrTrans: null,
				optionsMes: [
					{ value: null, text: this.$t('notmessage.filternotif.seealloptions') },
					{ value: 'CO', text: this.$t('notmessage.filternotif.seemessage') },
					{ value: 'MS', text: this.$t('notmessage.filternotif.seesms') },
					{ value: 'ME', text: this.$t('notmessage.filternotif.seeemail') },
					{ value: 'MES', text: this.$t('notmessage.filternotif.seemessageandsms') },
				],
				selectedMesOption: null,

				pdfSrc:'',
				pdfName:'list'
				// pdfFile: new Uint8Array([]),
				
			}
		},
		watch: {
			filter: function (newVal) {
				//if(newVal.length >= 2)
				this.getData()
			}
		},
		computed: {
			totalRowsText () {
				// let from = this.currentPage
				let from = ((this.currentPage-1) * this.perPage)+1
				let to = this.currentPage * this.perPage
				if(to > this.totalRows)
					to = this.totalRows
				let strTotalRows = this.$t('vtabTrans.showing') + ' '+ this.$store.getters.formatNumber(from) + ' ' + this.$t('vtabTrans.to') + '  '+ this.$store.getters.formatNumber(to) + ' ' + this.$t('vtabTrans.of')
				if(this.totalRows > 1)
					strTotalRows = strTotalRows+ ' '+ this.$store.getters.formatNumber(this.totalRows) + '  ' +this.$t('vtabTrans.records')
				else
					strTotalRows = strTotalRows +' '+this.$t('vtabTrans.one.record')
				return strTotalRows
			},
		},
		created() {
			for(let i = 0; i < this.instanceClassAttr.attrsList.length; i++) {
				if(this.instanceClassAttr.attrsList[i].attrImport !== true){
					let columnHeader = this.instanceClassAttr.attrsList[i].attrLabel?this.instanceClassAttr.attrsList[i].attrLabel:this.instanceClassAttr.attrsList[i].attrName; 
					
					let field = {}
					field.key = this.instanceClassAttr.attrsList[i].attrName;
					if(this.instanceClassAttr.attrsList[i].attrTrans === true){
						this.attrTrans = this.instanceClassAttr.attrsList[i].attrName
						field.key = 'attrTrans'
					}
					// Ignore suf Lib à la fin pour label
					if(columnHeader != null && columnHeader.length > 3 &&  columnHeader.substring(columnHeader.length-3) === "Lib")
						columnHeader = columnHeader.substring(0,columnHeader.length-3)
					field.label = this.$t(this.instanceClassAttr.instanceClass + '.' + columnHeader);
					// new 
					field.thStyle = {width:  this.instanceClassAttr.attrsList[i].attrCol};
					
					this.fields.push(field)

					// new, Default true
					if(this.instanceClassAttr.attrsList[i].attrRep && this.instanceClassAttr.attrsList[i].attrRep != false){
						this.attrsRepList.push(this.instanceClassAttr.attrsList[i].attrRep)
						this.attrsRepLibList.push(field.label)
					}
					else if(this.instanceClassAttr.attrsList[i].attrRep != false){
						this.attrsRepList.push(this.instanceClassAttr.attrsList[i].attrName)
						this.attrsRepLibList.push(field.label)
					}
					// this.attrsRepList.push(this.instanceClassAttr.attrsList[i].attrName)


				}
			}
			if(this.instanceClassAttr.actCol.actDisplay)
				this.fields.push( { key: 'actions', label: this.$t('default.actions'), thStyle: {width:this.instanceClassAttr.actCol.thCol } })
			this.getData();
			
		},
		methods: {
			showModal(id, type) {
				this.selectedItemId = id;
				this.selectedModalType = type;
				this.$refs.componentModal.modalToggle();
			},
			refreshDataTable(type){
				this.getData()
			},
			async getData(){
				let instanceClass = this.instanceClassAttr.instanceClass
				
				let data = {
					start: (this.currentPage - 1) * this.perPage,
					length: this.perPage
				}
				for (let i = 0; i < this.instanceClassAttr.attrsList.length; i++) {
					let index = 'columns[' + i + ']'
					data[index + '[data]'] = this.instanceClassAttr.attrsList[i].attrName
					data[index + '[searchable]'] = this.instanceClassAttr.attrsList[i].searchable
					data[index + '[orderable]'] = this.instanceClassAttr.attrsList[i].sortable
				}
				data['search[value]'] = this.filter //'Arb'
				// data.typenot = 'ALL-MA'
				this.$store.dispatch('axiosGet', {
					domain: instanceClass, data: new URLSearchParams(data).toString(),
				})
				.then((response) => {
					this.items = response.data.rows
					this.totalRows = response.data.recordsTotal
				})
				.catch(error => {
					console.log( 'Datatable-getData - ERROR CATCH ==', error)
				})
			},
			async produce() {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				//console.log(' attrsRepList == ', this.attrsRepList )
				let strParams = "jasper=LIC&attrsRepList=" + this.attrsRepList.toString() +"&attrsRepLibList=" + this.attrsRepLibList.toString() + "&titreDoc="+ this.$t(this.instanceClassAttr.instanceClass +'.list') +"&strFormat=PDF"
				await this.$store.dispatch('axiosGet', {
					url: '/api/'+ this.instanceClassAttr.instanceClass +'/produce?' + strParams,
					strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));

					/*var fileLink = document.createElement('a');
					fileLink.href = fileURL;
					fileLink.setAttribute('download', this.$t(this.instanceClassAttr.instanceClass +'.list')+'.pdf');
					document.body.appendChild(fileLink);
					fileLink.click();*/

					
					this.pdfName = this.$t(this.instanceClassAttr.instanceClass +'.list')+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});

					// NEW 
					/*var reader = new FileReader();
					reader.readAsDataURL(new Blob([response.data])); 
					reader.onloadend = function() {
						var base64data = reader.result;
						this.pdfSrc = base64data
					}*/
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},
			onChangePerPage(val) {
				if(val == Number.MAX_SAFE_INTEGER)
					val = this.totalRows;
				this.perPage = val;
				this.getData();
			},
			onPageClick(event, page) {
				this.currentPage = page
				this.getData();
			},		
		}

	}
</script>
<style scoped>
</style>